import React, { useEffect, useRef, useState } from 'react'
import DrilldownTableSS from '../../../Components/Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import { getExcelPoFileReducer } from '../../../../../../redux/reducers/reducerSlices/ExcelPoFileReducer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { AppConstant } from '../../../../../Assests/AppConstant';
import CustomButton from '../../../../Common/CustomButton/CustomButton';
import { getUserSelector } from '../../../../../../redux/reducers/reducerSlices/UserReducer';
import TinyLoader from '../../../../Common/TinyLoader/TinyLoader';



const ExcelFileList = ({themeSelected,setShowSessionData,setSelectedSessionId}) => {
      const excelPoFileData = useSelector(getExcelPoFileReducer);
      const [poFileList, setPoFileList] = useState([]);
      const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);
      const dispatch = useDispatch();
      const [page, setPage] = useState(1);
       const user = useSelector(getUserSelector);
          const { userType, userAccountDetails, permissions } = user
        const divRef = useRef(null);
        const [isLoading, setLoading] = useState(false);
            const userPermission = useSelector(getUserSelector);
                const {selectedWarehouse} = userPermission;
    
  useEffect(() => {
    setTimeout(() => {
     getLogList();
    },0) 
  }, [page]);

  useEffect(() => {
    if (excelPoFileData.lastEvaluatedKey) {
      setLastEvaluatedKey(excelPoFileData.lastEvaluatedKey);
    } else {
      setLastEvaluatedKey(null);
    }
    setLoading(false);
  }, [excelPoFileData.lastEvaluatedKey]);



  
    useEffect(() => {
      if (excelPoFileData.poExcelFileListRes) {
        setPoFileList(excelPoFileData.poExcelFileListRes || []);  
      }
    }, [excelPoFileData.poExcelFileListRes]);

        const handelInfiniteScroll = (e) => {
          
          try {
            if (
              Math.floor(e.target.scrollHeight - e.target.scrollTop) <=
                e.target.clientHeight &&
               
              !isLoading
            ) {
              if (!lastEvaluatedKey && page !==1 ) return;
              setLoading(true);
              setPage((prev) => prev + 1);
            }
          } catch (error) {}
        };


        const getLogList = ()=>{
            if (page === 1 || lastEvaluatedKey) {
              let payload = {
                startDate: new Date(
                  new Date().setDate(new Date().getDate() - 30)
                ).toISOString(),
                endDate: new Date().toISOString(),
                lastEvaluatedKey: page === 1 ? null : lastEvaluatedKey,
                limit: 10,
                pageNo: page,
              };
                if (userType !== AppConstant.userPermission.usertypes.superAdmin && userType!==AppConstant.userPermission.usertypes.administrator) {
                  payload.warehouseId = selectedWarehouse.ID;
                }
              dispatch({
                type: sagaActions.GET_EXCEL_PO_FILE_LIST,
                payload: payload,
              });
            }
        }

        const titleDD = [
          { id: "serial", name: "S. No." },
          { id: "Warehouse", name: "Warehouse Name" },
          { id: "dock", name: "Dock" },
          { id: "fileName", name: "File Name" },
          { id: "status", name: "Status" },
          { id: "uploadedOn", name: "Uploaded On" },
          { id: "orignialFile", name: "Orignial File" },
          { id: "processedFile", name: "Processed File" },
          { id: "action", name: "Actions" },
        ];


    const formatListData = (data) => {
        return data.map((el, index) => ({
          0: index+1,
          1: el.warehouse || "-",
          2: el.dock || "-",
          3: el.fileName || "-",
          4: el.status ? showStatus(el) : "-",
          5: el.createdOn
            ? moment(el.createdOn).format(
                AppConstant.commonStrings.MM_DD_YYYY__HH_mm
              )
            : "-",
          6: el.unprocessedFileUrl
            ? showDownloadFile(el.unprocessedFileUrl)
            : "-",
          7: el.processedFileUrl ? showDownloadFile(el.processedFileUrl) : "-",
          8: getActions(el),
        }));
    };

    const showStatus =(el)=>{
      if (el.status === AppConstant.ttScheduleUpload.status.failed) {
         return `${el.status} ${el.failureReason ? "- "+ el.failureReason:""}`
      }else if(el.status !== AppConstant.ttScheduleUpload.status.dbInserted && el.retries > 2){
        return `${AppConstant.ttScheduleUpload.status.failed} - ${AppConstant.commonStrings.unknownStr}`
      }
      return el.status
    }

    const getActions = (data) => {
      return (<>
      <CustomButton
            className="addButton"
            onClick={() => {
              setSelectedSessionId(data.sessionId);
              setShowSessionData(true)}}
            title="View Details"
          />
      </>)
    }

    const showDownloadFile = (fileUrl) => {
      if (fileUrl) {
        return (
          <CustomButton
            className="addButton"
            onClick={() => window.open(fileUrl, "_blank")}
            title="Download"
          />
        )
      }
    }

    const getBodyData = () => formatListData(poFileList);


  return (
    <div
      className="eclipseOpsListContainer"
      style={{ maxHeight: userType === AppConstant.userPermission.usertypes.superAdmin || userType === AppConstant.userPermission.usertypes.administrator ? "55vh" : "65vh" }}
      onScroll={handelInfiniteScroll}
      ref={divRef}
    >
      <DrilldownTableSS
        key={Math.random()}
        themeSelected={themeSelected}
        bodyData={getBodyData()}
        titleData={titleDD}
        showCollapse={false}
        showInput={false}
        showSort={false}
        hasCollapsableContent={false}
        collapsableData={[]}
        accordionPrimaryIndex={1}
        drillDownReport={poFileList}
        initiateDrillDownReport={excelPoFileData.loading || false}
        loaderArray={9}
        sortingAction={sagaActions.SORT_SS_USER_TABLE}
        subRoot={{ pathName: "" }}
        showUTCTime={true}
      />
      {isLoading ? (
        <div className="d-flex justify-content-center w-100">
          <TinyLoader />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default ExcelFileList